<div *ngIf="loader; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <h1>Reporte de Reservas</h1>

    <div class="divButtons">
      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>FILES</mat-label>
        <mat-select
          [(value)]="selectNumberFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">Todos los Files</mat-option>
          <mat-option
            *ngFor="let numberFile of arrayFiles"
            [value]="numberFile"
            >{{ numberFile }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO FILE</mat-label>
        <mat-select
          [(value)]="selectEstadoFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let estadoFile of arrayEstadoFiles"
            value="{{ estadoFile }}"
            >{{ estadoFile }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CLIENTES</mat-label>
        <mat-select
          [(value)]="selectedCliente"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let cliente of arrayClientes"
            value="{{ cliente }}"
            >{{ cliente }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>PROVEEDOR</mat-label>
        <mat-select
          [(value)]="selectProveedor"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let proveedor of arrayProveedores"
            value="{{ proveedor }}"
            >{{ proveedor }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>NUM OS </mat-label>
        <mat-select
          [(value)]="selectNumOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let numOS of arrayNumOS" value="{{ numOS }}">{{
            numOS
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO OS</mat-label>
        <mat-select
          [(value)]="selectEstadoOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let optionSelect of arraySelectEstadoOS"
            value="{{ optionSelect }}"
            >{{ optionSelect }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <input
          matInput
          [(ngModel)]="searchValue"
          placeholder="Buscar"
          (ngModelChange)="applyFilterSelect()"
        />
      </mat-form-field>
    </div>

    <div class="example-container mat-elevation-z8" *ngIf="fileDataSource">
      <mat-table [dataSource]="fileDataSource" matSort>
        <ng-container matColumnDef="fileDisplayState">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Estado File
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.fileDisplayState }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nameEmpresa">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Cliente
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.fileName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número File
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.fileNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateRange">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Date
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.dateRange }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombreServicio">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Nombre Servicio
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.nombreServicio }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombreProveedor">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Nombre Proveedor
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row?.objProvider?.nombre }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numReserva">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número Reserva
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            <div class="icon-edit">
              {{ row.numReserva ? row.numReserva : "-" }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numOS">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            OS
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row?.numOS }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoReserva">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle dobleHeader"
          >
            Estado Reserva
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
            <div class="icon-edit">
              <ng-container [ngSwitch]="row.estadoReserva">
                <ng-container *ngSwitchCase="'ENVIADO'">ENVIADO</ng-container>
                <ng-container *ngSwitchCase="'CONFIRMED'"
                  >CONFIRMADO</ng-container
                >
                <ng-container *ngSwitchCase="'DENIED'">DENEGADO</ng-container>
                <ng-container *ngSwitchCase="'STANDBY'">EN ESPERA</ng-container>
                <ng-container *ngSwitchDefault>{{
                  row.estadoReserva
                }}</ng-container>
              </ng-container>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="archivos">
          <mat-header-cell *matHeaderCellDef class="headerStyle oneHeader">
            Archivos
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="bodyStyle oneHeader"
          >
            <button mat-icon-button (click)="openDialog(element)">
              <mat-icon class="icon-color">upload</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="fileDisplayedColumns"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: fileDisplayedColumns"> </mat-row>
      </mat-table>
    </div>
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</ng-template>
